export default __webpack_public_path__ + "static/media/sc28.1c8187de.mp4";